import React from 'react';
import DocumentViewer from '../components/DocumentViewer';
import { useMarkdownContent } from '../hooks/useMarkdownContent';

const CommissionFeeStructurePage: React.FC = () => {
  const { content, loading, error } = useMarkdownContent('commission-fee-structure.md');

  if (loading) {
    return (
      <div className="max-w-4xl mx-auto p-6">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-500 mx-auto"></div>
          <p className="mt-2 text-gray-600">Loading Commission & Fee Structure...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="max-w-4xl mx-auto p-6">
        <div className="text-center text-red-600">
          <p>Error loading Commission & Fee Structure: {error}</p>
        </div>
      </div>
    );
  }

  return (
    <DocumentViewer
      content={content}
      title="Commission & Fee Structure"
      filename="baakas-commission-fee-structure"
    />
  );
};

export default CommissionFeeStructurePage;